import { render, staticRenderFns } from "./MensagemTela.vue?vue&type=template&id=4dd08d48&scoped=true&"
import script from "./MensagemTela.vue?vue&type=script&lang=js&"
export * from "./MensagemTela.vue?vue&type=script&lang=js&"
import style0 from "./MensagemTela.vue?vue&type=style&index=0&id=4dd08d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd08d48",
  null
  
)

export default component.exports